import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';

import { and } from './utils/and';

const hasManagedEntities = () => getFlag(FlagType.ManagedEntities);

export const canUseManagedEntities: Permission = and([hasManagedEntities]);
